import { FCWithChildren } from '@types';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { IUserDevice } from 'sdk-apogee';

import { AiOutlineReload } from 'react-icons/ai';

import { AddDeviceButton, Button, DashedButton, Loading, SeparatorLine } from '@components';

import Device from '../Device';
import EmptyDevices from '../EmptyDevices';
import { DeviceStatus } from '../../../constants';
import usePackages from '@hooks/usePackages';

type WebDevicesListProps = {
  addDeviceAnchorHandler?: () => void;
  devices: IUserDevice[];
  loading: boolean;
  openStatusInfoModal: (str: string) => void;
  refresh: () => void;
  showFooter?: boolean;
  showActiveOnly: boolean;
};

const WebDevicesList: FCWithChildren<WebDevicesListProps> = ({
  addDeviceAnchorHandler,
  devices,
  loading,
  openStatusInfoModal,
  refresh,
  showFooter = true,
  showActiveOnly,
}) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { data: packages = [] } = usePackages();

  const handleAddDeviceClick = () =>
    pathname === '/home'
      ? history.push({ pathname: '/manage-devices', state: { isAddingDevice: true } })
      : addDeviceAnchorHandler
      ? addDeviceAnchorHandler()
      : null;

  const upgradeHandler = () => history.push('/services');

  return (
    <>
      {devices.length ? (
        <div className="overflow-hidden rounded-2xl shadow-sm">
          <div>
            {loading ? (
              <div className="my-8 flex w-full justify-center">
                <Loading />
              </div>
            ) : (
              devices
                .filter(
                  (d) =>
                    !showActiveOnly ||
                    [DeviceStatus.ACTIVE, DeviceStatus.ONLINE].includes(d.status),
                )
                .map((info) => (
                  <Device
                    key={`device-${info.id}`}
                    {...info}
                    openStatusInfoModal={openStatusInfoModal}
                  />
                ))
            )}
          </div>

          {showFooter && (
            <div className="flex flex-col space-y-4 px-5 py-4">
              <AddDeviceButton
                block
                className="px-4 py-2"
                layout="secondary"
                onClick={handleAddDeviceClick}
                size="noPadding"
              />
              <SeparatorLine />
              {packages.length > 1 && (
                <DashedButton title="Upgrade for More Devices" noIcon handler={upgradeHandler} />
              )}
            </div>
          )}
        </div>
      ) : (
        <EmptyDevices />
      )}
    </>
  );
};

export default WebDevicesList;
